import React, { useEffect, useState } from 'react';
import './ResetPasswordPage.scss';
import { Bounce, toast } from 'react-toastify';

import { useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../../data/api';
import CircularProgress from '@mui/material/CircularProgress'; // Importa el componente de progreso circular de MUI

export const ResetPasswordPage = ({  }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordResetSuccessful, setPasswordResetSuccessful] = useState(false);
    const [loading, setLoading] = useState(false); // Estado para controlar la carga
    const navigate = useNavigate();
    const { resetToken } = useParams();

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Aquí puedes agregar la lógica para enviar la contraseña nueva
        if (password !== confirmPassword) {
            toast.error('Las contraseñas no coinciden', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            return;
        }

        if (password.length < 6) {
            toast.error('La contraseña debe contener mínimo 6 caracteres', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            return;
        }

        setLoading(true); // Establece el estado de carga a true
        if (resetToken) {
            const resp = await resetPassword(password, resetToken);
            if (resp.status === 'success') {
                setPasswordResetSuccessful(true);
            } else {
                toast.error(resp.error, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                    transition: Bounce,
                });
            }
        }
        setLoading(false); // Establece el estado de carga a false después de completar el envío
    };

    const handleLogin = () => {
        navigate('/');
    };

    return (
        <div className="new-password-page">
            <div className="new-password-container">
                {!passwordResetSuccessful ? (
                    <>
                        <h2>Crear nueva contraseña</h2>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Nueva contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Confirmar contraseña"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            {loading ? ( // Mostrar el progreso circular mientras se está cargando
                                <CircularProgress size={24} />
                            ) : (
                                <button type="submit">Confirmar</button>
                            )}
                        </form>
                    </>
                ) : (
                    <>
                        <h2>Contraseña restablecida</h2>
                        <p>Tu contraseña se ha restablecido correctamente. Ahora puedes iniciar sesión con tu nueva contraseña.</p>
                        <button className='btn-finish-reset' onClick={handleLogin}>Iniciar sesión</button>
                    </>
                )}
            </div>
        </div>
    );
};
